// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"148":"b31626e9","950":"945e76dd"}[chunkId] + ".chunk.js";
};